// extracted by mini-css-extract-plugin
module.exports = {"square":"Square_square__2-hi9","content":"Square_content__JhItn"};